function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99996 9.33333C8.73634 9.33333 9.33329 8.73638 9.33329 8C9.33329 7.26362 8.73634 6.66666 7.99996 6.66666C7.26358 6.66666 6.66663 7.26362 6.66663 8C6.66663 8.73638 7.26358 9.33333 7.99996 9.33333Z",
  fill: "#101010"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99996 4.66667C8.73634 4.66667 9.33329 4.06971 9.33329 3.33333C9.33329 2.59695 8.73634 2 7.99996 2C7.26358 2 6.66663 2.59695 6.66663 3.33333C6.66663 4.06971 7.26358 4.66667 7.99996 4.66667Z",
  fill: "#101010"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99996 14C8.73634 14 9.33329 13.403 9.33329 12.6667C9.33329 11.9303 8.73634 11.3333 7.99996 11.3333C7.26358 11.3333 6.66663 11.9303 6.66663 12.6667C6.66663 13.403 7.26358 14 7.99996 14Z",
  fill: "#101010"
});

var SvgNotificationMore = function SvgNotificationMore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationMore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification-more.2c46b3df.svg";
export { ForwardRef as ReactComponent };